import './DragMatching.sass';
import React, {useEffect, useRef, useLayoutEffect, useState} from 'react';
import apiJSON from "../../../api/apiJSON";
import {gsap} from 'gsap'
import _ from 'lodash'
import {Draggable} from "gsap/Draggable";
import DragManager from "./DragManager";
import Button from "../../ui/Button/Button";
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";

const DragMatching = ({data, completed, next}) => {

    gsap.registerPlugin(Draggable);

    const [dragManager, setDragManager] = useState(null);
    const jsonData = apiJSON.get(data);
    const {scenario, dragWidth, dragHeight, dragColumns, dragRows, dropColumns, dropRows, topPadding} = jsonData;
    const [finished, setFinished] = useState(false);

    useLayoutEffect(() => {
        setDragManager(new DragManager());
    }, []);

    useEffect(() => {
        if (dragManager) {
            dragManager.initDrags(".drag-matching-drag-tile");
            dragManager.registerDrops(document.querySelectorAll(".drag-matching-drop"));
        }
    }, [dragManager])


    const handleSubmit = () => {
        let allCorrect = true;
        var drops = dragManager.getState();
        console.log("drops:" + drops)
        drops.map((drop, index) => {
            if (drop.drag) {
                let dragChoice = _.find(scenario.drags, {"id": drop.drag.id});
                if (dragChoice.target === drop.id) {
                    //set correct
                    setCorrect(drop)
                } else {
                    dragManager.resetDrag(drop.drag.id);
                    allCorrect = false;
                }
            } else {
                allCorrect = false;
            }
        })

        if (allCorrect) {
            completed();
            setFinished(true);
        }
    }

    const setCorrect = (dropProxy) => {
        let dragProxy = dropProxy.drag
        dragManager.disableDrop(dropProxy.id)
        dragManager.disableDrag(dragProxy.id);
        let target = dragProxy.target;
        target.style.backgroundColor = "#95c87f"
        target.style.boxShadow = "0px 0px 0px 0px rgba(0,0,0,0)";
        target.style.pointerevents = "none";
        target.style.pointer = "default";
        target.style.cursor = "inherit";
        target.style.zIndex = 20;
    }

    const getDragColumns = () => {
        return "repeat(" + dragColumns + ", minmax(0, 1fr))"
    }

    const getDragRows = () => {
        return "repeat(" + dragRows + ", minmax(0, 1fr))"
    }

    const getDropColumns = () => {
        return "repeat(" + dropColumns + ", minmax(0, 1fr))"
    }

    const getDropRows = () => {
        return "repeat(" + dropRows + ", minmax(0, 1fr))"
    }


    return (
        <div className="DragMatching"
             id="container">
            {
                finished && <EnhancedPopUp data={scenario.completed}
                                           onHide={next}/>
            }
            <div className="drag-matching-header-panel">
                {
                    scenario.title &&
                    <div className="drag-matching-header-title">
                        {scenario.title}
                    </div>
                }
                {
                    scenario.body &&
                    <div className="drag-matching-header-body">
                        {scenario.body}
                    </div>
                }
                {
                    scenario.instructions &&
                    <div className="drag-matching-header-instructions">
                        {scenario.instructions}
                    </div>
                }
            </div>
            <div className="drag-matching-drag-panel">
                {
                    <div className="drag-matching-grid"
                         style={{
                             "gridTemplateColumns": getDragColumns(),
                             "gridTemplateRows": getDragRows()
                         }}>
                        {
                            scenario.drags.map((d, i, index) => (
                                <div className="drag-matching-drag-tile"
                                     key={"drag" + i}
                                     id={"drag" + i}
                                     style={{
                                         "width": dragWidth,
                                         "height": dragHeight
                                     }}>
                                    <div className="drag-matching-drag-label">
                                        {d.label}
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                }
            </div>
            <div className="drag-matching-drop-panel">
                <div className="drag-matching-grid"
                     style={{
                         "gridTemplateColumns": getDropColumns(),
                         "gridTemplateRows": getDropRows()
                     }}>
                    {
                        scenario.drops.map((d, i) => (
                            <div className="drag-matching-drop"
                                 id={d.id}
                                 key={"drop" + i}
                                 style={{
                                     "width": dragWidth,
                                     "height": dragHeight
                                 }}>
                                <div className="drag-matching-drop-label">
                                    {d.label}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            <Button data={"Submit"}
                    callback={handleSubmit}
                    style={{
                        "position": "absolute",
                        "bottom": "1rem"
                    }}/>
        </div>
    );
};

export default DragMatching;